import React from 'react'
import { Container, Image, Toggle, Tools } from '@pmi/pmi-iqos-ds-react'

const SpotsFilters = ({ filters, toggleFilterHandler, paddingLeft = '8' }) => {
  const getLabel = item => {
    return (
      <Container display={Container.displays.flex}>
        {item && item.icon ? (
          <Container
            display={Container.displays.flex}
            alignItems={Container.alignItemsValues.center}
            width="6">
            <Image src={item.icon} />
          </Container>
        ) : null}
        <Container pl="1">{item.name}</Container>
      </Container>
    )
  }
  return filters
    ? filters.map((item, index) => (
        <Container
          key={index}
          pl={!Tools.isDesktop() && index === 0 ? paddingLeft : '0'}
          pr={[
            !Tools.isDesktop() && index === filters.length - 1 ? '8' : '1',
            '2'
          ]}
          pt="3">
          <Toggle
            name={'spots-filters'}
            checked={item.active}
            label={getLabel(item)}
            onChangeHandler={() => toggleFilterHandler(item)}
            design={Toggle.toggleDesigns.rounded}
            disabled={false}
          />
        </Container>
      ))
    : null
}

export default SpotsFilters
